import React from "react";
import { getGridStyle } from "./Grid.styles";
/**
 * Abstracting CSS Grid for easier use and consistency. Similar to how Fluent UI's Stack component is an abstraction of CSS flexbox.
 */
export const Grid = ({ tokens, children }) => {
    return React.createElement("div", { style: getGridStyle(tokens) }, children);
};
